<ion-header>
  <ion-toolbar mode="ios">
    <ion-back-button slot="start" text="" defaultHref="/home/survey" color="dark" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-back-button>
    <ion-title class="ion-no-padding">
      <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="surveyServ.activeSurveys && authServ.isLogged">
  <ion-row class="title">
    <ion-col size="12">
      <ion-label>
        {{"Please choose the one you want to answer from the surveys below." | translate}}
      </ion-label>
    </ion-col>
  </ion-row>

  <ng-container *ngFor="let survey of surveyServ.activeSurveys">

    <ion-row>
      <!-- <ion-col size="12">
        <ion-item routerLink="{{survey.id}}">
          <ion-avatar slot="start">
            <ion-icon size="large" name="clipboard-outline"></ion-icon>
          </ion-avatar>
          <ion-label>
            <h2><b>{{survey.name}}</b></h2>
            <h3>{{"Number of Questions: " | translate}}{{survey.survey_lines.length}}</h3>

            <p *ngIf="survey.description">{{survey.description}}</p>
          </ion-label>
        </ion-item>
      </ion-col> -->
      <ion-col size="12" routerLink="{{survey.id}}">
        <ion-card>
          <ion-icon color="primary" name="clipboard-outline"></ion-icon>
          <ion-card-header>
            <ion-card-title><b>{{survey.name | caption}}</b></ion-card-title>
            <ion-card-subtitle>{{"Number of Questions: " | translate}}{{survey.survey_lines.length}}</ion-card-subtitle>
          </ion-card-header>
        </ion-card>
      </ion-col>
    </ion-row>

  </ng-container>

</ion-content>
<ion-content *ngIf="!authServ.isLogged">
  <ion-row>
    <ion-col class="error" sizeLg="6" offsetLg="3" size="12">
      <ion-icon color="medium" name="log-in-outline" style="font-size: 128px;"></ion-icon><br>
      <ion-text color="medium" class="ion-margin">
        <h2> {{"Please login to answer the surveys." | translate}}</h2>
      </ion-text>
    </ion-col>
  </ion-row>
</ion-content>